import { ApiSchedule } from '../../types';

/**
 * A suggestion says how often an order should go, and nothing else.
 *
 * It used to be spread straight over the draft, which took the delivery address and the end date
 * with it - so picking "varannan vecka" quietly unset the address the customer had chosen, and the
 * schedule was saved without one. What belongs to the subscription is kept; what belongs to the
 * rhythm is replaced.
 */
export const applySuggestion = (current: ApiSchedule, suggestion: ApiSchedule): ApiSchedule => ({
	...suggestion,
	id: current?.id,
	productListId: current?.productListId,
	startDate: current?.startDate,
	endDate: endDateFor(current?.startDate, current?.endDate),
	deliveryAddress: current?.deliveryAddress,
});

/**
 * An end date only survives while it is still after the start.
 *
 * The suggestions screen chooses a first-order date but shows no end date, so one left from an
 * earlier rhythm can end up before the new start - a schedule that is over before it begins, with
 * nothing on screen to correct it. It has to be checked wherever that screen moves either date, not
 * only when a rhythm is picked. The advanced form shows the end date, so there it is left alone and
 * the customer can see for themselves what to change.
 *
 * Both are `YYYY-MM-DD`, which orders the same way as a string and as a date.
 */
export const endDateFor = (startDate?: string, endDate?: string): string | undefined =>
	endDate && startDate && endDate < startDate ? undefined : endDate;
